// Translator notes: temporal lo-clauses and "before" (engine/src/passes/when-past.ts, rules/temporal-clauses.ts),
// the "…, only X" remnant clause (rules/particles.ts EN_ONLY_REMNANT) and English noun + noun (rules/en-senses.ts).
// Each id is an engine note (`notes.add(text, id, args)`); `args` names its arguments in the order the
// strings take them. Collected by translator/notes.ts (import.meta.glob): adding a note means adding it here.
import { defineNotes } from '../note-defs';

export const notes = defineNotes({
  whenPastIndicative: {
    args: [],
    fi: () =>
      'Kun-lause kertoo yhdestä menneestä tapahtumasta, joten lo-lauseen verbi on indikatiivin menneessä ajassa. Subjunktiivi kuuluu yleiseen ”aina kun” -merkitykseen (oppitunti 39).',
    en: () =>
      'The when-clause tells of one past event, so the verb after lo is in the indicative past. The subjunctive belongs to a general “whenever” (lesson 39).',
  },
  beforeAdverb: {
    args: ['hv', 'also'],
    fi: (a: string[]) =>
      `”Before” ilman jatkoa on ajan adverbi ${a[0]} ’aiemmin’ (oppitunti 41). Peterson käyttää myös pelkkää sanaa ${a[1]} (”daorys gō istas” = kukaan ei ole mennyt aiemmin).`,
    en: (a: string[]) =>
      `“Before” with nothing after it is the time adverb ${a[0]} “previously” (lesson 41). Peterson also uses ${a[1]} alone (“daorys gō istas” = no one has gone before).`,
  },
  nounCompound: {
    args: ['word'],
    fi: (a: string[]) =>
      `Englannin substantiivi toisen edessä: ”${a[0]}” on genetiivissä sen sanan edellä, jota se kuvaa. Valyriassa ei ole väljiä yhdyssanoja (Peterson: ”iēdro pikības”), joten sano suhde tarkemmin, jos se jää epäselväksi.`,
    en: (a: string[]) =>
      `English noun before a noun: “${a[0]}” is in the genitive before the noun it describes. High Valyrian has no loose compounds (Peterson: “iēdro pikības”), so say the relation more exactly if it is unclear.`,
  },
  onlyRemnant: {
    args: [],
    fi: () => 'Pilkun jälkeinen ”vain …” toistaa edellisen lauseen objektin, joten se on samassa sijassa kuin objekti.',
    en: () => 'The “only …” after the comma repeats the object of the clause before it, so it takes the same case as the object.',
  },
});

declare module '../note-defs' {
  interface NoteIds extends Record<keyof typeof notes, true> {}
}
